import { fork, put, call, take } from 'redux-saga/effects';
import { REQUEST } from 'redux-config/reduxHelpers';
import { acceptError } from 'common/_redux';
import * as actionTypes from './actions';
import * as api from '../api';

export function* getAllConfigurationItemsSaga() {
  try {
    const responseData = yield call(api.getAllConfigurationItems);
    console.log('API response data:', responseData);

    // 从responseData中提取detail数组或直接使用responseData
    const configurationItemsData = responseData && responseData.detail ? responseData.detail : responseData || [];
    yield put(actionTypes.getAllConfigurationItems.success(configurationItemsData));
  } catch (e) {
    const errorMessage = e.message || '获取配置项列表失败';
    yield put(acceptError(errorMessage, true));
    yield put(actionTypes.getAllConfigurationItems.failure());
  }
}

export function* getAllConfigurationItemsWatcherSaga() {
  while (true) {
    yield take(actionTypes.GET_ALL_CONFIGURATION_ITEMS[REQUEST]);
    yield call(getAllConfigurationItemsSaga);
  }
}

const watchers = [fork(getAllConfigurationItemsWatcherSaga)];

export default watchers;
